module.exports = {
        srcSet: __webpack_public_path__ + "destination_host_tesco-178-34a080efd9d98a05.digested.png"+" 178w",
        images: [{path: __webpack_public_path__ + "destination_host_tesco-178-34a080efd9d98a05.digested.png",width: 178,height: 48}],
        src: __webpack_public_path__ + "destination_host_tesco-178-34a080efd9d98a05.digested.png",
        toString: function(){return __webpack_public_path__ + "destination_host_tesco-178-34a080efd9d98a05.digested.png"},
        
        width: 178,
        height: 48
      }